module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"param":{"numberToKeep":"Maximum number of entities to keep","dropFullyMentioned":"Drop entities already fully contained in the collection, as they are not useful"}}}')
  delete Component.options._Ctor
}
